import Util from '@/libs/util'
//  获取竣工信息列表
export function gettxJgxxpage(params) {
  return Util.http({
    url: `/api/txJgxx/page`,
    method: 'get',
    params
  })
}
//  获取竣工信息详情
export function gettxJgxxget(params) {
  return Util.http({
    url: `/api/txJgxx/get`,
    method: 'get',
    params
  })
}

//  获取行业资讯列表
export function gettxHyzxpage(params) {
  return Util.http({
    url: `/api/txHyzx/page`,
    method: 'get',
    params
  })
}
//  获取行业资讯详情
export function gettxHyzxget(params) {
  return Util.http({
    url: `/api/txHyzx/get`,
    method: 'get',
    params
  })
}
//  获取会员单位详情
export function gettxHydwget(params) {
  return Util.http({
    url: `/api/txHydw/get`,
    method: 'get',
    params
  })
}
//  获取协会动态列表
export function gettxXhdtpage(params) {
  return Util.http({
    url: `/api/txXhdt/page`,
    method: 'get',
    params
  })
}
//  获取协会动态详情
export function gettxXhdtget(params) {
  return Util.http({
    url: `/api/txXhdt/get`,
    method: 'get',
    params
  })
}

//  获取寓意生活列表
export function gettxYyshpage(params) {
  return Util.http({
    url: `/api/txYysh/page`,
    method: 'get',
    params
  })
}
//  获取寓意生活详情
export function gettxYyshget(params) {
  return Util.http({
    url: `/api/txYysh/get`,
    method: 'get',
    params
  })
}
//  获取共建共享列表
export function gettxPolicypage(params) {
  return Util.http({
    url: `/api/txPolicy/page`,
    method: 'get',
    params
  })
}
//  获取共建共享详情
export function gettxPolicyget(params) {
  return Util.http({
    url: `/api/txPolicy/get`,
    method: 'get',
    params
  })
}
//  获取业务交流列表
export function gettxExchangepage(params) {
  return Util.http({
    url: `/api/txExchange/page`,
    method: 'get',
    params
  })
}
//  获取业务交流详情
export function gettxExchangeget(params) {
  return Util.http({
    url: `/api/txExchange/get`,
    method: 'get',
    params
  })
}
//  获取通知公告列表
export function gettxNoticepage(params) {
  return Util.http({
    url: `/api/txNotice/page`,
    method: 'get',
    params
  })
}
//  获取通知公告详情
export function gettxNoticeget(params) {
  return Util.http({
    url: `/api/txNotice/get`,
    method: 'get',
    params
  })
}
//  获取如何入会
export function gettxRhrhpage(params) {
  return Util.http({
    url: `/api/txRhrh/page`,
    method: 'get',
    params
  })
}

//  获取协会简介
export function gettxXhjjpage(params) {
  return Util.http({
    url: `/api/txXhjj/page`,
    method: 'get',
    params
  })
}
//  获取协会章程
export function gettxXhzcpage(params) {
  return Util.http({
    url: `/api/txXhzc/page`,
    method: 'get',
    params
  })
}
//  获取协会领导
export function gettxXhldpage(params) {
  return Util.http({
    url: `/api/txXhld/page`,
    method: 'get',
    params
  })
}
//  获取协会组织机构
export function gettxZzjgpage(params) {
  return Util.http({
    url: `/api/txZzjg/page`,
    method: 'get',
    params
  })
}
//  获取协会组织机构详情
export function gettxZzjgget(params) {
  return Util.http({
    url: `/api/txZzjg/get`,
    method: 'get',
    params
  })
}
//  获取会员单位列表
export function gettxHydwpage(params) {
  return Util.http({
    url: `/api/txHydw/page`,
    method: 'get',
    params
  })
}
//  获取联系我们
export function gettxConcatpage(params) {
  return Util.http({
    url: `/api/txConcat/page`,
    method: 'get',
    params
  })
}
//  获取曝光台列表
export function gettxBgtpage(params) {
  return Util.http({
    url: `/api/txBgt/page`,
    method: 'get',
    params
  })
}
//  获取曝光台详情
export function gettxBgtget(params) {
  return Util.http({
    url: `/api/txBgt/get`,
    method: 'get',
    params
  })
}
//  获取接入证明列表
export function gettxJrzmpage(params) {
  return Util.http({
    url: `/api/txJrzm/page`,
    method: 'get',
    params
  })
}
//  获取接入证明详情
export function gettxJrzmget(params) {
  return Util.http({
    url: `/api/txJrzm/get`,
    method: 'get',
    params
  })
}




//获取工单汇总
export function queryWorkOrderForScreen(data) {
  return Util.http({
    url: `/api/warningInfoReports/queryWorkOrderForScreen`,
    method: 'post',
    data
  })
}


export function txRegistrationMans() {
  return Util.http({
    url: `https://www.sztia.cn:443/up/api/txRegistrationMans/kasbm`,
    method: 'get'
  })
}

export function txDeveloperCreate(data) {
  return Util.http({
    url: `https://www.sztia.cn:443/up/api/txDevelopers/saveOrUpdateTxDeveloper`,
    method: 'post',
    data: data
  })
}
//开发名称校验用户
export function gettxRegistrationMans(data) {
  return Util.http({
    url: `https://www.sztia.cn:443/up/api/txRegistrationMans/selectByRepeatUser`,
    method: 'post',
    data
  })
}

// 开发名称校验
export function gettxRegistrationMansname(data) {
  return Util.http({
    url: `https://www.sztia.cn:443/up/api/txDevelopers/selectDistinctMc`,
    method: 'post',
    data
  })
}